import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-pressed"]
const _hoisted_2 = {
  key: 0,
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 223.0171508789 182.1359863281",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 223.0170898438 182.1359863281",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_4 = ["aria-pressed"]
const _hoisted_5 = {
  key: 0,
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 223.0171508789 182.1359863281",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 223.0170898438 182.1359863281",
  focusable: "false",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('message-feedback ')),
    role: "region"
  }, [
    _createElementVNode("button", {
      class: _normalizeClass({
			[_ctx.getClass('thumb')]: true,
			[_ctx.getClass('thumb--up')]: true,
			[_ctx.getClass('thumb--active')]: _ctx.isThumbsUp,
			[_ctx.getClass('thumb--disabled')]: _ctx.isInCooldown
		}),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggleThumbsUp && _ctx.toggleThumbsUp(...args))),
      "aria-pressed": _ctx.isThumbsUp,
      "aria-label": "Helpful",
      title: "Helpful",
      type: "button",
      ref: "btnHelpful"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.getClass('thumb__icon')),
        "aria-hidden": "true"
      }, [
        (!_ctx.isThumbsUp)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
              _createCommentVNode(" Hollow/Inactive Thumbs up SVG "),
              _cache[2] || (_cache[2] = _createElementVNode("g", { "data-name": "Layer 1" }, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M217.5531616211,69.2116088867c-3.6430053711-3.6427001953-7.8930053711-5.4639892578-12.75-5.4639892578h-58.7389526367l10.0179443359-39.6146240234v-3.1873779297c0-1.6696166992-.3419799805-3.4149780273-1.0249633789-5.2363891602-.6830444336-1.8212890625-1.5549926758-3.2632446289-2.6180419922-4.3257446289l-11.3829345703-11.3834838867-63.748046875,63.7476196289v118.3883666992h100.174987793c3.491027832,0,6.8300170898-1.0629882812,10.0170288086-3.1869506836,3.1879882812-2.125,5.4639892578-4.7060546875,6.8300170898-7.741027832l27.3209838867-64.2030029297c.3029785156-1.0629882812.6069946289-2.2009887695.9099731445-3.4149780273.3040161133-1.2139892578.4559936523-2.3530273438.4559936523-3.4150390625v-18.2138061523c0-4.8569946289-1.8219604492-9.1067504883-5.4639892578-12.7495727539ZM204.8031616211,100.174987793l-27.3200073242,63.7470092773h-81.9613647461v-92.4337158203l39.6143798828-39.614440918-12.2940063477,50.0873413086h81.9609985352v18.2138061523Z",
                    fill: "currentcolor"
                  }),
                  _createElementVNode("path", {
                    d: "M18.0144042969,63.7475585938H0v118.3883666992h63.5484008789V63.7475585938H18.0144042969ZM45.334777832,163.9219360352h-27.1212158203v-81.9608154297h27.1212158203v81.9608154297Z",
                    fill: "currentcolor"
                  })
                ])
              ], -1 /* HOISTED */))
            ]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createCommentVNode(" Solid/Active Thumbs up SVG "),
              _cache[3] || (_cache[3] = _createElementVNode("g", { "data-name": "Layer 2" }, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M217.5531005859,69.2116088867c-3.6430053711-3.6427001953-7.8930053711-5.4639892578-12.75-5.4639892578h-58.7388916016l10.0179443359-39.6146240234v-3.1873779297c0-1.6696166992-.3419799805-3.4149780273-1.0249633789-5.2363891602-.6830444336-1.8212890625-1.5549926758-3.2632446289-2.6180419922-4.3257446289l-11.3829345703-11.3834838867-63.748046875,63.7476196289v118.3883666992h100.174987793c3.491027832,0,6.8300170898-1.0629882812,10.0170288086-3.1869506836,3.1879882812-2.125,5.4639892578-4.7060546875,6.8300170898-7.741027832l27.3209228516-64.2030029297c.3029785156-1.0629882812.6069946289-2.2009887695.9099731445-3.4149780273.3040161133-1.2139892578.4559936523-2.3530273438.4559936523-3.4150390625v-18.2138061523c0-4.8569946289-1.8219604492-9.1067504883-5.4639892578-12.7495727539Z",
                    fill: "currentcolor"
                  }),
                  _createElementVNode("polygon", {
                    points: "18.0144042969 63.7475585938 0 63.7475585938 0 182.135925293 18.0144042969 182.135925293 45.533996582 182.135925293 63.5484008789 182.135925293 63.5484008789 63.7475585938 45.533996582 63.7475585938 18.0144042969 63.7475585938",
                    fill: "currentcolor"
                  })
                ])
              ], -1 /* HOISTED */))
            ]))
      ], 2 /* CLASS */)
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    _createElementVNode("button", {
      class: _normalizeClass({
			[_ctx.getClass('thumb')]: true,
			[_ctx.getClass('thumb--down')]: true,
			[_ctx.getClass('thumb--active')]: _ctx.isThumbsDown,
			[_ctx.getClass('thumb--disabled')]: _ctx.isInCooldown
		}),
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleThumbsDown && _ctx.toggleThumbsDown(...args))),
      "aria-pressed": _ctx.isThumbsDown,
      "aria-label": "Unhelpful",
      title: "Unhelpful",
      type: "button",
      ref: "btnUnhelpful"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.getClass('thumb__icon')),
        "aria-hidden": "true"
      }, [
        (!_ctx.isThumbsDown)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [
              _createCommentVNode(" Hollow/Inactive Thumbs down SVG "),
              _cache[4] || (_cache[4] = _createElementVNode("g", { "data-name": "Layer 3" }, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M5.4639892578,112.9243774414c3.6430053711,3.6427001953,7.8930053711,5.4639892578,12.75,5.4639892578h58.7389526367l-10.0179443359,39.6146240234v3.1873779297c0,1.6696166992.3419799805,3.4149780273,1.0249633789,5.2363891602.6830444336,1.8212890625,1.5549926758,3.2632446289,2.6180419922,4.3257446289l11.3829345703,11.3834838867,63.748046875-63.7476196289V0H45.533996582c-3.491027832,0-6.8300170898,1.0629882812-10.0170288086,3.1869506836-3.1879882812,2.125-5.4639892578,4.7060546875-6.8300170898,7.741027832L1.3659667969,75.1309814453c-.3029785156,1.0629882812-.6069946289,2.2009887695-.9099731445,3.4149780273-.3040161133,1.2139892578-.4559936523,2.3530273438-.4559936523,3.4150390625v18.2138061523c0,4.8569946289,1.8219604492,9.1067504883,5.4639892578,12.7495727539ZM18.2139892578,81.9609985352l27.3200073242-63.7470092773h81.9613647461v92.4337158203l-39.6143798828,39.614440918,12.2940063477-50.0873413086H18.2139892578v-18.2138061523Z",
                    fill: "currentcolor"
                  }),
                  _createElementVNode("path", {
                    d: "M205.002746582,118.3884277344h18.0144042969V.0000610352h-63.5484008789v118.3883666992h45.533996582ZM177.6823730469,18.214050293h27.1212158203v81.9608154297h-27.1212158203V18.214050293Z",
                    fill: "currentcolor"
                  })
                ])
              ], -1 /* HOISTED */))
            ]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_6, [
              _createCommentVNode(" Solid/Active Thumbs down SVG "),
              _cache[5] || (_cache[5] = _createElementVNode("g", { "data-name": "Layer 4" }, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M5.4639892578,112.9243774414c3.6430053711,3.6427001953,7.8930053711,5.4639892578,12.75,5.4639892578h58.7388916016l-10.0179443359,39.6146240234v3.1873779297c0,1.6696166992.3419799805,3.4149780273,1.0249633789,5.2363891602.6830444336,1.8212890625,1.5549926758,3.2632446289,2.6180419922,4.3257446289l11.3829345703,11.3834838867,63.748046875-63.7476196289V0H45.5339355469c-3.491027832,0-6.8300170898,1.0629882812-10.0170288086,3.1869506836-3.1879882812,2.125-5.4639892578,4.7060546875-6.8300170898,7.741027832L1.3659667969,75.1309814453c-.3029785156,1.0629882812-.6069946289,2.2009887695-.9099731445,3.4149780273-.3040161133,1.2139892578-.4559936523,2.3530273438-.4559936523,3.4150390625v18.2138061523c0,4.8569946289,1.8219604492,9.1067504883,5.4639892578,12.7495727539Z",
                    fill: "currentcolor"
                  }),
                  _createElementVNode("polygon", {
                    points: "205.0026855469 118.3884277344 223.0170898438 118.3884277344 223.0170898438 .0000610352 205.0026855469 .0000610352 177.4830932617 .0000610352 159.4686889648 .0000610352 159.4686889648 118.3884277344 177.4830932617 118.3884277344 205.0026855469 118.3884277344",
                    fill: "currentcolor"
                  })
                ])
              ], -1 /* HOISTED */))
            ]))
      ], 2 /* CLASS */)
    ], 10 /* CLASS, PROPS */, _hoisted_4)
  ], 2 /* CLASS */))
}